import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  IFilterComponent,
  SearchFilter,
} from "../../../../infrastructure/iFilter-component";
import { FilterService } from "../../../../services/filter.service";
import { AuthService } from "../../../../services/auth.service";
import { FilterRecordService } from "../../../../services/filter-record.service";
import { CashDeskService } from "../../../../services/cash-desk.service";
import { NotificationToastService } from "../../../../services/notification-toast.service";

@Component({
  selector: "cash-desk-manual-filter",
  templateUrl: "./cash-desk-manual-filter.component.html",
  styleUrls: ["./cash-desk-manual-filter.component.css"],
})
export class CashDeskManualFilterComponent implements IFilterComponent, OnInit {
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private authService: AuthService,
    private cashDeskService: CashDeskService,
    private notificationToastService: NotificationToastService,
    private filterRecordService: FilterRecordService
  ) {
    this.form = this.formBuilder.group({
      CreateDate: [new Date()],
      Number: [""],
      BusinessName: [""],
    });
  }

  get f() {
    return this.form.controls;
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "CashDeskManualFilterComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "CashDeskManualFilterComponent",
      this.form
    );
  }

  async search(): Promise<any> {
    if (
      !this.form.controls.CreateDate.value &&
      !this.form.controls.Number.value &&
      !this.form.controls.BusinessName.value
    ) {
      this.notificationToastService.error(
        "Debe ingresar algún criterio de búsqueda",
        "Cobranza manual"
      );
      return null;
    } else {
      return await this.cashDeskService.getCashDeskManualSearchItem(
        this.authService.getCompanyIds(),
        this.form.controls.BusinessName.value,
        this.form.controls.Number.value,
        this.form.controls.CreateDate.value
          ? <Date>this.form.controls.CreateDate.value
          : null
      );
    }
  }

  async ngOnInit() {}
}
